import SubsectionCard from "../SubsectionCard";

const FormattingSection = ({ formatting }) => {
  const formattingHeader = formatting["Subsection A - Header"];
  const formattingWordCount = formatting["Subsection B - Number of words"];
  const formattingDate = formatting["Subsection C - Proper date"];
  const formattingSalutation = formatting["Subsection D - Proper Salutation"];
  const formattingPatient = formatting["Subsection E - Identifying Patient"];
  const formattingParagraphs = formatting["Subsection F - Paragraphs"];
  const formattingEndingSalutation =
    formatting["Subsection G - Ending Salutation with Signature"];

  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Formatting{" "}
          {formattingHeader.Score +
            formattingWordCount.Score +
            formattingDate.Score +
            formattingSalutation.Score +
            formattingPatient.Score +
            formattingParagraphs.Score +
            formattingEndingSalutation.Score}
          /70 - (40% of total grade)
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <div className="writingGradeSectionSubsectionWrapper">
          <SubsectionCard
            title="Header"
            feedbackText={formattingHeader.Feedback}
            score={`${formattingHeader.Score}/10`}
            postfix={"(10% of total grade)"}
          />

          <SubsectionCard
            title="Number of words"
            feedbackText={formattingWordCount.Feedback}
            score={`${formattingWordCount.Score}/10`}
            postfix={"(5% of total grade)"}
          />
          <SubsectionCard
            title="Proper Date"
            feedbackText={formattingDate.Feedback}
            score={`${formattingDate.Score}/10`}
            postfix={"(5% of total grade)"}
          />
          <SubsectionCard
            title="Proper Salutation"
            feedbackText={formattingSalutation.Feedback}
            score={`${formattingSalutation.Score}/10`}
            postfix={"(5% of total grade)"}
          />
          <SubsectionCard
            title="Identifying Patient"
            feedbackText={formattingPatient.Feedback}
            score={`${formattingPatient.Score}/10`}
            postfix={"(5% of total grade)"}
          />
          <SubsectionCard
            title="Paragraphs"
            feedbackText={formattingParagraphs.Feedback}
            score={`${formattingParagraphs.Score}/10`}
            postfix={"(5% of total grade)"}
          />
          <SubsectionCard
            title="Ending Salutation with Signature"
            feedbackText={formattingEndingSalutation.Feedback}
            score={`${formattingEndingSalutation.Score}/10`}
            postfix={"(5% of total grade)"}
          />
        </div>
      </div>
    </div>
  );
};

export default FormattingSection;
